/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line
  const variantsOnSaleCache = new Map();
  const productDataCache = new WeakMap();

  function parseVariantsOnSale(variantsOnSaleData) {
    if (!variantsOnSaleData || variantsOnSaleData.trim() === '') return {};
    if (variantsOnSaleCache.has(variantsOnSaleData)) return variantsOnSaleCache.get(variantsOnSaleData);

    const variantsOnSale = {};
    const entries = variantsOnSaleData.split(',');
    entries.forEach(function(entry) {
      if (entry.includes(':')) {
        const parts = entry.split(':');
        const id = parts[0];
        const isOnSale = parts[1];
        if (id && isOnSale !== undefined) {
          variantsOnSale[id.trim()] = isOnSale.trim() === 'true';
        }
      }
    });

    variantsOnSaleCache.set(variantsOnSaleData, variantsOnSale);
    return variantsOnSale;
  }

  function getProductData(scope) {
    var root = scope && scope.closest
      ? (scope.closest('[data-product-block], .product-single, .popup-quick-view, [data-section-id]') || document)
      : document;
    var productJson = root.querySelector('[data-product-json]') || document.querySelector('[data-product-json]');
    if (!productJson) return null;

    if (productDataCache.has(productJson)) return productDataCache.get(productJson);

    try {
      var parsed = JSON.parse(productJson.textContent);
      productDataCache.set(productJson, parsed);
      return parsed;
    } catch (error) {
      console.error('Invalid product JSON:', error);
      return null;
    }
  }

  // Color name updater for product swatches
  document.addEventListener('DOMContentLoaded', function() {
    
    // Function to update color name display
    function updateColorName(input) {
      const colorName = input.getAttribute('data-color-name');
      const swatchContainer = input.closest('[data-swatches-container]');
      
      if (swatchContainer && colorName) {
        const colorNameDisplay = swatchContainer.querySelector('[data-selected-color-name]');
        if (colorNameDisplay) {
          colorNameDisplay.textContent = colorName;
        }
      }
    }

    // Use delegated listener to avoid many per-input handlers.
    document.addEventListener('change', function(event) {
      const input = event.target.closest('.swatch__input[data-color-name], .radio__input[data-color-name]');
      if (input && input.checked) updateColorName(input);
    });

    // Initialize with currently selected color on page load
    const checkedSwatchInput = document.querySelector('.swatch__input[data-color-name]:checked');
    if (checkedSwatchInput) {
      updateColorName(checkedSwatchInput);
    }

    const checkedRadioInput = document.querySelector('.radio__input[data-color-name]:checked');
    if (checkedRadioInput) {
      updateColorName(checkedRadioInput);
    }
  });

  // Log on-sale variant data when swatch is clicked
  document.addEventListener('DOMContentLoaded', function() {
    
    // Handle swatch button clicks
    document.addEventListener('click', function(event) {
      const swatchButton = event.target.closest('[data-swatch-button]');
      
      if (swatchButton) {
        const productBlock = swatchButton.closest('[data-product-block]');
        const swatchLabel = swatchButton.querySelector('[data-swatch-variant]');
        
        if (productBlock && swatchLabel) {
          const variantsOnSaleData = productBlock.dataset.variantsOnSale;
          const variantId = swatchLabel.dataset.swatchVariant;
          
          try {
            const variantsOnSale = parseVariantsOnSale(variantsOnSaleData);
            
            const isVariantOnSale = variantsOnSale[variantId];
            
            const redSaleBadge = productBlock.querySelector('.product-badge__item--sale-red');
            const customBadge = productBlock.querySelector('.product-badge__item--custom');
            
            if (isVariantOnSale) {
              if (redSaleBadge) { redSaleBadge.style.display = ''; redSaleBadge.classList.remove('hidden'); }
              if (customBadge) { customBadge.style.display = 'none'; customBadge.classList.add('hidden'); }
            } else {
              if (redSaleBadge) { redSaleBadge.style.display = 'none'; redSaleBadge.classList.add('hidden'); }
              if (customBadge) { customBadge.style.display = ''; customBadge.classList.remove('hidden'); }
            }
          } catch (error) {
            console.error('Error parsing variants on sale data:', error);
          }
        }
      }
    });

    // Handle product page variant selection (dropdowns, radio buttons, etc.)
    document.addEventListener('change', function(event) {
      const selector = event.target.closest('[data-single-option-selector]');
      
      if (selector) {
        const productForm = selector.closest('form[data-product-form]');
        
        if (productForm) {
          setTimeout(() => {
            const variantInput = productForm.querySelector('input[name="id"]');
            
            if (variantInput) {
              const currentVariantId = variantInput.value;
              const variantsOnSaleData = productForm.dataset.variantsOnSale;
            
              try {
                const variantsOnSale = parseVariantsOnSale(variantsOnSaleData);
                
                const isVariantOnSale = variantsOnSale[currentVariantId];
                
                let redSaleBadge = productForm.querySelector('.product-badge__item--sale-red');
                let customBadge = productForm.querySelector('.product-badge__item--custom');
                
                if (!redSaleBadge) {
                  const productContainer = productForm.closest('[data-product-block]') || document;
                  redSaleBadge = productContainer.querySelector('.product-badge__item--sale-red');
                  customBadge = customBadge || productContainer.querySelector('.product-badge__item--custom');
                }
                
                if (isVariantOnSale) {
                  if (redSaleBadge) { redSaleBadge.style.display = ''; redSaleBadge.classList.remove('hidden'); }
                  if (customBadge) { customBadge.style.display = 'none'; customBadge.classList.add('hidden'); }
                } else {
                  if (redSaleBadge) { redSaleBadge.style.display = 'none'; redSaleBadge.classList.add('hidden'); }
                  if (customBadge) { customBadge.style.display = ''; customBadge.classList.remove('hidden'); }
                }
              } catch (error) {
                console.error('Error parsing variants on sale data:', error);
              }
            }
          }, 100);
        }
      }
    });
  });

  // Video modal functionality
  document.addEventListener('DOMContentLoaded', function() {
    document.addEventListener('click', function(event) {
      const videoBadge = event.target.closest('[data-video-modal-trigger]');
      const closeBtn = event.target.closest('[data-video-modal-close]');
      const modalBackdrop = event.target.classList.contains('video-modal') ? event.target : null;
      
      if (videoBadge) {
        event.preventDefault();
        const videoUrl = videoBadge.getAttribute('data-video-url');
        const uniqueId = videoBadge.getAttribute('data-video-modal-trigger') || 'default';
        
        let modal = document.getElementById('video-modal-' + uniqueId);
        if (!modal) {
          modal = createVideoModal(uniqueId);
          document.body.appendChild(modal);
        }
        
        loadVideoContent(modal, videoUrl, uniqueId);
        
        modal.style.display = 'flex';
        modal.style.visibility = 'visible';
        modal.style.opacity = '1';
        modal.classList.add('modal-visible');
        document.body.style.overflow = 'hidden';
        
        setTimeout(() => {
          modal.style.setProperty('display', 'flex', 'important');
          modal.style.setProperty('position', 'fixed', 'important');
          modal.style.setProperty('top', '0', 'important');
          modal.style.setProperty('left', '0', 'important');
          modal.style.setProperty('width', '100vw', 'important');
          modal.style.setProperty('height', '100vh', 'important');
          modal.style.setProperty('z-index', '10000', 'important');
          modal.style.setProperty('background', 'rgba(0,0,0,0.9)', 'important');
        }, 10);
        return;
      }

      if (closeBtn) {
        closeVideoModal(closeBtn.getAttribute('data-video-modal-close'));
        return;
      }

      if (modalBackdrop) {
        closeVideoModal(modalBackdrop.id.replace('video-modal-', ''));
      }
    });

    document.addEventListener('keydown', function(event) {
      if (event.key === 'Escape') {
        const openModal = document.querySelector('.video-modal[style*="flex"]');
        if (openModal) {
          const uniqueId = openModal.id.replace('video-modal-', '');
          closeVideoModal(uniqueId);
        }
      }
    });
  });

  // Create video modal function
  function createVideoModal(uniqueId) {
    const modal = document.createElement('div');
    modal.id = 'video-modal-' + uniqueId;
    modal.className = 'video-modal';
    modal.style.cssText = 'display: none; position: fixed; top: 0; left: 0; width: 100%; height: 100%; background: rgba(0,0,0,0.8); z-index: 9999; align-items: center; justify-content: center;';
    
    modal.innerHTML = `
      <div class="video-modal-content" style="position: relative; width: 90%; max-width: 800px; background: white; border-radius: 8px; padding: 20px;">
        <button 
          class="video-modal-close" 
          data-video-modal-close="${uniqueId}"
          style="position: absolute; top: 10px; right: 15px; background: none; border: none; font-size: 24px; cursor: pointer; color: #666;"
        >
          Ã—
        </button>
        <div class="video-container" style="width: 100%; height: 450px; background: #000; border-radius: 4px; display: flex; align-items: center; justify-content: center;">
          <div id="video-content-${uniqueId}" style="width: 100%; height: 100%;">
          </div>
        </div>
      </div>
    `;
    
    return modal;
  }

  // Load video content function
  function loadVideoContent(modal, videoUrl, uniqueId) {
    const videoContainer = modal.querySelector('#video-content-' + uniqueId);
    if (!videoContainer) return;
    
    videoContainer.innerHTML = '';
    
    let videoId = null;
    
    if (videoUrl && videoUrl.includes('<iframe') && videoUrl.includes('</iframe>')) {
      const srcMatch = videoUrl.match(/src="[^"]*\/embed\/([^"?]*)/);
      if (srcMatch && srcMatch[1]) videoId = srcMatch[1];
    } else if (videoUrl && videoUrl.trim() !== '') {
      videoId = extractYouTubeId(videoUrl);
    }
    
    if (videoId) {
      videoContainer.innerHTML = `
        <div style="width: 100%; height: 100%; background: #000; display: flex; align-items: center; justify-content: center;">
          <iframe 
            src="https://www.youtube.com/embed/${videoId}?autoplay=1&mute=1&enablejsapi=1" 
            width="100%" height="100%" frameborder="0" 
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
            allowfullscreen style="min-height: 400px; min-width: 600px;"
          ></iframe>
        </div>
      `;
    } else {
      videoContainer.innerHTML = `
        <div style="background: #333; color: white; padding: 40px; text-align: center; border-radius: 8px;">
          <h3>Watch Video</h3>
          <p>Click the link below to watch the video:</p>
          <a href="${videoUrl}" target="_blank" style="color: #ff0000; font-size: 18px; text-decoration: underline;">ðŸŽ¥ Open Video</a>
          <br><br>
          <p style="font-size: 14px; opacity: 0.8;">Opens in a new tab</p>
        </div>
      `;
    }
    
    setTimeout(() => {
      if (!videoContainer.querySelector('iframe[src*="youtube"]')) {
        videoContainer.innerHTML = `
          <div style="background: #333; color: white; padding: 40px; text-align: center; border-radius: 8px;">
            <h3>Watch Video</h3>
            <p>Click the link below to watch the video:</p>
            <a href="${videoUrl}" target="_blank" style="color: #ff0000; font-size: 18px; text-decoration: underline;">ðŸŽ¥ Open Video</a>
            <br><br>
            <p style="font-size: 14px; opacity: 0.8;">Opens in a new tab</p>
          </div>
        `;
      }
    }, 3000);
  }

  // Close video modal function
  function closeVideoModal(uniqueId) {
    const modal = document.getElementById('video-modal-' + uniqueId);
    if (modal) {
      modal.style.display = 'none';
      document.body.style.overflow = '';
      const videoContainer = modal.querySelector('#video-content-' + uniqueId);
      if (videoContainer) videoContainer.innerHTML = '';
    }
  }

  // Extract YouTube video ID
  function extractYouTubeId(url) {
    const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
    const match = url.match(regExp);
    return (match && match[2].length === 11) ? match[2] : null;
  }

  // Extract Vimeo video ID
  function extractVimeoId(url) {
    const regExp = /(?:vimeo)\.com.*(?:videos|video|channels|)\/([\d]+)/i;
    const match = url.match(regExp);
    return match ? match[1] : null;
  }

  // Ensure Opinew plugin is visible after load
  document.addEventListener('DOMContentLoaded', function() {
    setTimeout(function() {
      const opinewPlugin = document.getElementById('opinew-plugin');
      if (opinewPlugin) {
        opinewPlugin.style.display = '';
        opinewPlugin.style.visibility = 'visible';
        opinewPlugin.style.opacity = '1';
      }
      const opinewContainer = document.getElementById('opinew-reviews-product-page-code');
      if (opinewContainer) {
        opinewContainer.style.display = '';
        opinewContainer.style.visibility = 'visible';
      }
    }, 100);
  });

  // SKU updater - updates SKU display when variant changes
  document.addEventListener('theme:variant:change', function(event) {
    const variant = event.detail.variant;
    const skuElements = document.querySelectorAll('[id^="ProductSku-"]');
    skuElements.forEach(function(skuElement) {
      skuElement.textContent = (variant && variant.sku) ? variant.sku : 'Not available';
    });
  });

  // Remove DISPOSE and RECYCLING_FEE items from cart
  document.addEventListener("DOMContentLoaded", function() {
    const typesToRemove = new Set(['DISPOSE', 'RECYCLING_FEE']);
    let attempts = 0;
    const maxAttempts = 6;

    function removeUnwantedCartItems() {
      return fetch('/cart.js')
        .then(function(response) { return response.json(); })
        .then(function(cart) {
          const updates = {};
          cart.items.forEach(function(item) {
            if (typesToRemove.has(item.product_type)) updates[item.id] = 0;
          });

          if (Object.keys(updates).length === 0) return false;

          return fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ updates: updates })
          }).then(function() { return true; });
        })
        .catch(function(error) {
          console.error('Error cleaning cart:', error);
          return false;
        });
    }

    function runCleanup() {
      attempts += 1;
      removeUnwantedCartItems().then(function(hasRemoved) {
        if (!hasRemoved || attempts >= maxAttempts) return;
        setTimeout(runCleanup, 1200);
      });
    }

    runCleanup();
  });

  function getActiveOptionInputs(scope, dataIndex) {
    if (!scope) return [];

    return Array.from(scope.querySelectorAll(
      '.radio__input[data-index="' + dataIndex + '"], .swatch__input[data-index="' + dataIndex + '"], input[data-popout-input][data-index="' + dataIndex + '"]'
    )).filter(function(input) {
      return !input.disabled;
    });
  }

  function getCheckedOptionInput(scope, dataIndex) {
    if (!scope) return null;
    return scope.querySelector(
      '.radio__input[data-index="' + dataIndex + '"]:checked:not(:disabled), .swatch__input[data-index="' + dataIndex + '"]:checked:not(:disabled), input[data-popout-input][data-index="' + dataIndex + '"]:not(:disabled)'
    );
  }

  function selectOptionValue(scope, dataIndex, targetValue) {
    if (!scope || !targetValue) return false;
    var normalizedTarget = String(targetValue).toLowerCase();
    var optionInputs = getActiveOptionInputs(scope, dataIndex);

    for (var i = 0; i < optionInputs.length; i += 1) {
      var input = optionInputs[i];
      if (String(input.value).toLowerCase() !== normalizedTarget) continue;

      if (input.matches('.radio__input, .swatch__input')) {
        input.click();
        input.dispatchEvent(new Event('change', { bubbles: true }));
        return true;
      }
    }

    var popoutInput = scope.querySelector('input[data-popout-input][data-index="' + dataIndex + '"]:not(:disabled)');
    if (!popoutInput) return false;

    var popoutRoot = popoutInput.closest('popout-select');
    var optionToClick = null;
    if (popoutRoot) {
      optionToClick = Array.from(popoutRoot.querySelectorAll('[data-popout-option]')).find(function(option) {
        var value = (option.getAttribute('data-value') || '').toLowerCase();
        return value === normalizedTarget;
      });
    }

    if (optionToClick) {
      optionToClick.click();
    } else {
      popoutInput.value = targetValue;
      popoutInput.dispatchEvent(new Event('input', { bubbles: true }));
      popoutInput.dispatchEvent(new Event('change', { bubbles: true }));
    }

    return true;
  }

  function findActiveProductFormForOption(dataIndex) {
    var forms = Array.from(document.querySelectorAll('form[data-product-form]')).filter(function(form) {
      return form.offsetParent !== null;
    });
    for (var i = 0; i < forms.length; i += 1) {
      if (getActiveOptionInputs(forms[i], dataIndex).length > 0) return forms[i];
    }
    return document.querySelector('form[data-product-form]');
  }

  function getSelectedOptionsByIndex(scope, optionsCount) {
    var selected = new Array(optionsCount);
    if (!scope) return selected;

    for (var i = 0; i < optionsCount; i += 1) {
      var dataIndex = 'option' + (i + 1);
      var selectedInput = getCheckedOptionInput(scope, dataIndex);
      selected[i] = selectedInput ? selectedInput.value : null;
    }

    return selected;
  }

  function findMatchingVariant(productData, selectedOptions) {
    if (!productData || !selectedOptions) return null;
    return productData.variants.find(function(variant) {
      for (var i = 0; i < selectedOptions.length; i += 1) {
        var selectedValue = selectedOptions[i];
        if (selectedValue == null) continue;
        if (variant.options[i] !== selectedValue) return false;
      }
      return true;
    }) || null;
  }

  function findAvailableFallbackVariant(productData, selectedOptions, sizeOptionIndex, colorOptionIndex) {
    if (!productData || !selectedOptions) return null;

    return productData.variants.find(function(variant) {
      if (!variant.available) return false;

      for (var i = 0; i < selectedOptions.length; i += 1) {
        if (i === colorOptionIndex) continue;

        var selectedValue = selectedOptions[i];
        if (selectedValue == null) continue;
        if (variant.options[i] !== selectedValue) return false;
      }

      // Explicitly enforce the requested size value.
      if (sizeOptionIndex > -1 && selectedOptions[sizeOptionIndex] != null) {
        if (variant.options[sizeOptionIndex] !== selectedOptions[sizeOptionIndex]) return false;
      }

      return true;
    }) || null;
  }

  function runAvailabilityCorrection(productForm) {
    if (!productForm) return;

    const productData = getProductData(productForm);
    if (!productData) return;
    const options = productData.options;

    const colorOptionIndex = options.findIndex(function(opt) {
      return opt.toLowerCase() === 'color';
    });
    const sizeOptionIndex = options.findIndex(function(opt) {
      return opt.toLowerCase() === 'size';
    });

    if (colorOptionIndex === -1 || sizeOptionIndex === -1) return;

    const colorDataIndex = 'option' + (colorOptionIndex + 1);
    const selectedOptions = getSelectedOptionsByIndex(productForm, options.length);
    if (!selectedOptions[sizeOptionIndex] || !selectedOptions[colorOptionIndex]) return;

    // If current selection is available, do nothing.
    const currentVariant = findMatchingVariant(productData, selectedOptions);
    if (currentVariant && currentVariant.available) return;

    // Otherwise, keep all non-color options and switch color to first available.
    const fallback = findAvailableFallbackVariant(productData, selectedOptions, sizeOptionIndex, colorOptionIndex);
    if (!fallback) return;

    const fallbackColor = fallback.options[colorOptionIndex];
    if (fallbackColor !== selectedOptions[colorOptionIndex]) {
      selectOptionValue(productForm, colorDataIndex, fallbackColor);
    }
  }

  // Auto-select Queen size on page load
  function initQueenSelect(retryCount) {
    const currentRetry = retryCount || 0;
    // If coming from the sale collection, respect the variant and skip auto-select
    if (document.referrer.includes('/collections/sale') && window.location.search.includes('variant=')) return;

    const productForm = findActiveProductFormForOption('option1');
    if (!productForm) return;

    const productData = getProductData(productForm);
    if (!productData) return;
    const options = productData.options;

    const sizeOptionIndex = options.findIndex(function(opt) {
      return opt.toLowerCase() === 'size';
    });

    if (sizeOptionIndex === -1) return;

    const dataIndex = 'option' + (sizeOptionIndex + 1);

    const sizeInputs = getActiveOptionInputs(productForm, dataIndex);

    if (sizeInputs.length === 0) {
      if (currentRetry < 40) {
        setTimeout(function() {
          initQueenSelect(currentRetry + 1);
        }, 100);
      }
      return;
    }

    var selectedSize = null;
    if (selectOptionValue(productForm, dataIndex, 'queen')) {
      selectedSize = 'Queen';
    } else if (selectOptionValue(productForm, dataIndex, 'full/queen')) {
      selectedSize = 'Full/Queen';
    } else {
      return;
    }

    // After selecting Queen, check if current color is available and switch if not
    var colorOptionIndex = options.findIndex(function(opt) {
      return opt.toLowerCase() === 'color';
    });

    if (colorOptionIndex === -1) return;

    var colorDataIndex = 'option' + (colorOptionIndex + 1);

    setTimeout(function() {
      var checkedColor = getCheckedOptionInput(productForm, colorDataIndex);
      if (!checkedColor) return;

      var selectedOptions = getSelectedOptionsByIndex(productForm, options.length);
      selectedOptions[sizeOptionIndex] = selectedSize;
      selectedOptions[colorOptionIndex] = checkedColor.value;

      // Check if current full option combination is available.
      var currentVariant = findMatchingVariant(productData, selectedOptions);

      if (currentVariant && currentVariant.available) return;

      // Find first available variant preserving all non-color selections.
      var fallback = findAvailableFallbackVariant(productData, selectedOptions, sizeOptionIndex, colorOptionIndex);

      if (fallback) {
        var fallbackColor = fallback.options[colorOptionIndex];
        selectOptionValue(productForm, colorDataIndex, fallbackColor);
      }
    }, 200);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initQueenSelect);
  } else {
    initQueenSelect();
  }

  // Sync collection card swatches from active URL color filter values on initial load.
  // This triggers the same swatch-click logic that correctly sets featured + hover media.
  function initCollectionFilterSwatchSync() {
    const normalize = function(value) {
      return (value || '')
        .toString()
        .toLowerCase()
        .replace(/[-_]+/g, ' ')
        .replace(/\s+/g, ' ')
        .trim();
    };

    const canonicalize = function(value) {
      return normalize(value).replace(/[^a-z0-9]/g, '');
    };

    const toHandle = function(value) {
      return (value || '')
        .toString()
        .toLowerCase()
        .trim()
        .replace(/[^a-z0-9\s-]/g, '')
        .replace(/\s+/g, '-');
    };

    const getActiveFilterValuesForLabel = function(label) {
      const labelHandle = toHandle(label);
      const values = [];

      const collectionRoot = document.querySelector('[data-active-option-filters]');
      const activeOptionFilters = collectionRoot ? (collectionRoot.getAttribute('data-active-option-filters') || '') : '';

      if (activeOptionFilters) {
        activeOptionFilters.split(',').forEach(function(pair) {
          if (!pair) return;
          const separatorIndex = pair.indexOf(':');
          if (separatorIndex === -1) return;

          const key = pair.slice(0, separatorIndex);
          const rawValue = pair.slice(separatorIndex + 1);
          if (!key.startsWith('filter.v.option.')) return;
          if (!key.includes(labelHandle)) return;
          if (rawValue) values.push(rawValue);
        });
      }

      if (values.length) return values;

      const params = new URLSearchParams(window.location.search);

      params.forEach(function(rawValue, key) {
        if (!key.startsWith('filter.v.option.')) return;
        if (!key.includes(labelHandle)) return;

        rawValue.split(',').forEach(function(value) {
          if (value) values.push(value);
        });
      });

      return values;
    };

    const applyFilterDrivenSwatchState = function(root) {
      const scope = root || document;
      let appliedCount = 0;
      scope.querySelectorAll('product-grid-item-swatch[data-swatch-label]').forEach(function(swatchGroup) {
        if (swatchGroup.dataset.filterSyncApplied === 'true') return;

        const filterValues = getActiveFilterValuesForLabel(swatchGroup.dataset.swatchLabel);
        if (!filterValues.length) return;

        const normalizedFilters = filterValues.map(normalize);
        const canonicalFilters = filterValues.map(canonicalize);
        const target = Array.from(swatchGroup.querySelectorAll('[data-swatch]')).find(function(swatch) {
          const raw = swatch.getAttribute('data-swatch');
          const swatchValue = normalize(raw);
          const swatchCanonical = canonicalize(raw);
          return normalizedFilters.includes(swatchValue) || canonicalFilters.includes(swatchCanonical);
        });

        if (!target) return;

        const button = target.closest('[data-swatch-button]');
        const swatchLink = (target.nextElementSibling && target.nextElementSibling.matches('a[data-swatch-variant]'))
          ? target.nextElementSibling
          : (button ? button.querySelector('a[data-swatch-variant]') : null);
        const clickTarget = swatchLink || button || target;

        // Palo Alto's swatch handler updates media only in "mouse" mode (body.no-outline).
        const hadNoOutline = document.body.classList.contains('no-outline');
        if (!hadNoOutline) document.body.classList.add('no-outline');
        let originalHref = null;
        if (swatchLink && swatchLink.hasAttribute('href')) {
          originalHref = swatchLink.getAttribute('href');
          swatchLink.removeAttribute('href');
        }
        clickTarget.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true }));
        if (swatchLink && originalHref !== null) {
          swatchLink.setAttribute('href', originalHref);
        }
        if (!hadNoOutline) document.body.classList.remove('no-outline');
        swatchGroup.dataset.filterSyncApplied = 'true';
        appliedCount += 1;
      });
      return appliedCount;
    };

    const runWithRetries = function(root, retriesLeft) {
      const applied = applyFilterDrivenSwatchState(root || document);
      if (applied > 0 || retriesLeft <= 0) return;
      setTimeout(function() {
        runWithRetries(root, retriesLeft - 1);
      }, 120);
    };

    const scheduleSync = function(root) {
      requestAnimationFrame(function() {
        runWithRetries(root || document, 18);
      });
    };

    if (window.customElements && window.customElements.whenDefined) {
      window.customElements.whenDefined('product-grid-item-swatch').then(function() {
        scheduleSync(document);
      });
    } else {
      scheduleSync(document);
    }

    document.addEventListener('shopify:section:load', function(event) {
      scheduleSync(event.target);
    });

    document.addEventListener('theme:resize', function() {
      scheduleSync(document);
    });

    const collectionProductsRoot = document.querySelector('[data-collection-products]');
    if (collectionProductsRoot && window.MutationObserver) {
      const observer = new MutationObserver(function(mutations) {
        const hasNewNodes = mutations.some(function(mutation) {
          return mutation.addedNodes && mutation.addedNodes.length > 0;
        });
        if (hasNewNodes) scheduleSync(collectionProductsRoot);
      });

      observer.observe(collectionProductsRoot, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCollectionFilterSwatchSync);
  } else {
    initCollectionFilterSwatchSync();
  }

  // NOTE:
  // Intentionally do not auto-correct variant selections after initial load.
  // This allows customers to select sold-out combinations and see restock UI.

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
